import { $ } from '@/libs/jquery/index'

$.validator.addMethod('date', function(value: string, element: HTMLElement): boolean {
  const isCorrect: boolean = (/^([0-2]+[0-9]+|30|31)[\.-]+(0+[0-9]+|10|11|12)[\.-]+\d{4}$/i)
    .test(value)

  return this.optional(element) || isCorrect
}, 'Укажите верную дату')
